<!-- <p>force-upgrade works!</p> -->
<div>
    <div class="breadcrumb">
        <p>
            <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
            <span>App Release</span>
        </p>
    </div>

    <div class="container">
        <div class="left-container">
            <mat-card>
                <form [formGroup]="releaseForm" (submit)="onForceUpgradeSubmit(formDirective)" novalidate
                    #formDirective="ngForm">
                    <div fxLayout="column" class="ota-container" fxLayoutGap="10">

                        <mat-form-field appearance="outline" class="custom-input-field">
                            <mat-label>Platform Type</mat-label>
                            <mat-select placeholder="Select Platform Type" formControlName="selectedPlatformType">
                                <mat-option value="android">Android</mat-option>
                                <mat-option value="ios">iOS</mat-option>
                                <mat-option value="both">Both</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="custom-input-field">
                            <mat-label>App Version</mat-label>
                            <input matInput formControlName="versionNo"
                                placeholder="Version should be like 1.2.3 and not v1.2.3" class="OTA-font" required>
                            <mat-error
                                *ngIf="releaseForm.get('versionNo')?.hasError('required') && releaseForm.get('versionNo')?.touched">
                                App version Value is required.
                            </mat-error>

                            <!-- SemVer error -->
                            <mat-error *ngIf="releaseForm.get('versionNo')?.hasError('semverInvalid')">
                                Version must follow semantic versioning (e.g. 1.2.3)
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="custom-input-field">
                            <mat-label>Release Type</mat-label>
                            <mat-select placeholder="Select Release Type" formControlName="selecteReleaseType">
                                <mat-option value="normal">Normal Release</mat-option>
                                <mat-option value="force">Critical Release</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="custom-input-field">
                            <mat-label>Release Notes - English</mat-label>
                            <textarea matInput formControlName="releaseNotesEnglish"
                                placeholder="Release Notes - English" class="OTA-font" required></textarea>
                            <mat-error
                                *ngIf="releaseForm.get('Description')?.hasError('required') && releaseForm.get('Description')?.touched">
                                Description is required.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="custom-input-field">
                            <mat-label>Release Notes - Canada</mat-label>
                            <textarea matInput formControlName="releaseNotesCanada" placeholder="Release Notes - Canada"
                                class="OTA-font" required></textarea>
                            <mat-error
                                *ngIf="releaseForm.get('Description')?.hasError('required') && releaseForm.get('Description')?.touched">
                                Description is required.
                            </mat-error>
                        </mat-form-field>



                        <div fxLayoutAlign="end center" class="action-btn-container">
                            <button mat-raised-button color="primary" type="button" (click)="onClear()">
                                Clear
                            </button>
                            <button mat-raised-button color="primary" type="submit" [disabled]="releaseForm.invalid">
                                <!-- Create Force Upgrade Request -->
                                {{buttonTitle}}
                            </button>
                        </div>
                    </div>
                </form>
            </mat-card>
        </div>
        <div class="right-container">
            <div class="filters-view">
                <mat-form-field appearance="outline" class="filter-field">
                    <mat-select placeholder="View Android" [(value)]="selectedPlatformFilter"
                        (selectionChange)="onPlatformFilterChange($event.value)">
                        <mat-option value="android">View Android</mat-option>
                        <mat-option value="ios">View iOS</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="filter-field">
                    <mat-select placeholder="Select Action" [formControl]="actionControl"
                        (selectionChange)="onActionChange($event.value)" [disabled]="selectedRowCount === 0">

                        <mat-option value="update">Update</mat-option>
                        <mat-option value="delete">Delete</mat-option>

                    </mat-select>
                </mat-form-field>

            </div>


            <div class="ota-list-container">
                <ag-grid-angular style="width: 100%; height: 490px;" class="ag-theme-alpine" [gridOptions]="gridOptions"
                    [columnDefs]="columnDefs" [rowData]="rowData" (gridReady)="onGridReady($event)"
                    (selectionChanged)="onSelectionChanged()"></ag-grid-angular>
            </div>
        </div>
    </div>

</div>